import { Article } from 'interfaces/ArticleTypes';
import { ZendeskArticle, ZendeskCategory } from 'interfaces/ZendeskArticle';
import { useQuery } from '@tanstack/react-query';

import { MyToverAPI } from 'api/MyToverAPI';

interface ArticleListResponse {
  data: Article[];
  meta: { total: number };
}

interface ArticleListParams {
  page?: number;
  perPage?: number;
  title?: string;
}

export const articleKeys = {
  all: ['articles'] as const,
  list: (params: ArticleListParams) => ['articles', 'list', params] as const,
  detail: (id: string) => ['articles', id] as const,
  public: (id: string, locale?: string) => ['articles', 'public', id, locale] as const,
  category: (id: string, locale?: string) => ['categories', id, locale] as const,
};

export const useArticlesPaginated = (params: ArticleListParams) =>
  useQuery<ArticleListResponse>({
    queryKey: articleKeys.list(params),
    queryFn: () => MyToverAPI.getArticles(params).then((r) => r.parsed as ArticleListResponse),
  });

export const useManageArticle = (id: string) =>
  useQuery<Article>({
    queryKey: articleKeys.detail(id),
    queryFn: () => MyToverAPI.getArticle(id, null, true).then((r) => r.parsed.data as Article),
    enabled: !!id,
  });

export const usePublicArticle = (id: string, locale?: string) =>
  useQuery<ZendeskArticle>({
    queryKey: articleKeys.public(id, locale),
    queryFn: () => MyToverAPI.getArticle(id, locale).then((r) => r.parsed.data as ZendeskArticle),
    enabled: !!id,
  });

export const useCategory = (id: string, locale?: string) =>
  useQuery<ZendeskCategory>({
    queryKey: articleKeys.category(id, locale),
    queryFn: () => MyToverAPI.getCategory(id).then((r) => r.parsed.data as ZendeskCategory),
    enabled: !!id,
  });
